import { collection, getDocs, query, where } from "@firebase/firestore";
import { db } from "../../../firebase";

const GetAllStudentsOfClass = async (SchoolID, ClassID) => {
  try {
    const UsersCollection = collection(db, "Users");

    const q = query(
      UsersCollection,
      where("SchoolID", "==", SchoolID),
      where("AdditionalDetails.ClassID", "==", ClassID),
      where("UserType", "==", "student"),
      where("IsDeleted", "==", false)
    );
    const StudentsSnapshot = await getDocs(q);

    let StudentsData = [];

    StudentsSnapshot.forEach((doc) => {
      StudentsData.push({ ...doc.data(), id: doc.id });
    });
    return StudentsData;
  } catch (error) {
    console.log(error);
  }
};

export default GetAllStudentsOfClass;
